import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { H3 } from '@mxenabled/mxui'

import { useGlobalCopyStore, useUserStore } from '../../../common'

import { getCreditScoreState } from '../../util/finstrongUtils'

import StatusChip from '../StatusChip'

const CreditScoreHeader = () => {
  const { finstrong: copy } = useGlobalCopyStore()
  const { user } = useUserStore()

  const status = getCreditScoreState(user.credit_score ?? null)

  return (
    <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
      <H3>{copy.credit_score_keep_strong_credit_score}</H3>
      <StatusChip status={status} />
    </Stack>
  )
}

export default observer(CreditScoreHeader)
